import { MenuItem, Select } from '@mui/material';
import { documentTypeOptions } from '@pages/onboarding/Mexico/constants';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IDocumentUsaTypeId } from '@efex-services/documents/types';
import { useFormContext } from 'react-hook-form';
import StakeHolderContext from '../context/StakeHolderContext';

const DOCUMENT_TYPE_OPTIONS = {
  INE: 'INE',
  PASS: 'PASS',
};

const getDocumentType = (documentId: number | undefined) => {
  if (!documentId) return '';

  if ([IDocumentUsaTypeId.PASSPORT].includes(documentId))
    return DOCUMENT_TYPE_OPTIONS.PASS;

  if (
    [
      IDocumentUsaTypeId.PERSONAL_ID,
      IDocumentUsaTypeId.PERSONAL_ID_BACK,
    ].includes(documentId)
  )
    return DOCUMENT_TYPE_OPTIONS.INE;

  return '';
};

interface GovermentIdSelectorProps {
  value: string;
  onChange: (value: string) => void;
  validateTypeFile: (value: string) => void;
}

const GovermentIdSelector = ({
  value,
  onChange,
  validateTypeFile,
}: GovermentIdSelectorProps) => {
  const { t } = useTranslation();

  const {
    formState: { errors },
  } = useFormContext();

  const { govermentIdDocuments, handleChangeTypeOfGovernmentId } =
    useContext(StakeHolderContext);

  useEffect(() => {
    const firstValidDocument =
      govermentIdDocuments.documentOne ??
      govermentIdDocuments.documentTwo ??
      undefined;

    const documentType = getDocumentType(firstValidDocument?.document?.type.id);

    if (documentType) {
      validateTypeFile(documentType);
      onChange(documentType);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [govermentIdDocuments]);

  return (
    <Select
      labelId="idType"
      className="custom-textfield"
      error={!!errors.idType}
      value={value}
      onChange={(event) => {
        const selectedValue = event.target.value;
        handleChangeTypeOfGovernmentId();
        validateTypeFile(selectedValue);
        onChange(selectedValue);
      }}
    >
      {documentTypeOptions.map((idType) => (
        <MenuItem key={idType.value} value={idType.value}>
          {t(idType.value)}
        </MenuItem>
      ))}
    </Select>
  );
};

export default GovermentIdSelector;
